import {
  Box,
  Flex,
  Grid,
  Text,
  useDisclosure,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BlueButton } from "~/routes/_shared/Buttons";
import { UserIcon } from "../../_shared/UserIcon";
import { UserSidebar } from "../_shared/Sidebar";
import { useCreateUserMutation, useMyUserGroupQuery } from "./index.generated";

export const UserMyUserGroupUsers = () => {
  const [res] = useMyUserGroupQuery();

  const userGroup = res.data?.myUserGroup;
  if (!userGroup) return null;
  const users = userGroup.users;
  return (
    <Flex>
      <UserSidebar />
      <Box bgColor={"#16181a"} flexGrow={1} p={10}>
        <Flex
          flexDir="row"
          flexWrap="wrap"
          alignContent="center"
          justifyContent="space-between"
          py={2}
          my={4}
        >
          <Text fontSize={40} color="white" fontWeight={"bold"} mb={8}>
            ユーザー一覧
          </Text>
          <Flex gap={2}>
            <CreateUserModal />
          </Flex>
        </Flex>
        <Grid templateColumns="repeat(6, 1fr)" gap={8} mb={4}>
          {users.map((user) => {
            return <UserIcon key={user.id} user={user} />;
          })}
        </Grid>
      </Box>
    </Flex>
  );
};

const CreateUserModal = ({}: {}) => {
  const toast = useToast();
  const [createUserRes, createUser] = useCreateUserMutation();

  const [name, setName] = useState("");
  const [isValidName, setIsValidName] = useState(false);
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (name.length === 0) {
      setIsValidName(false);
    } else if (name.includes(" ")) {
      setIsValidName(false);
    } else if (name.includes("　")) {
      setIsValidName(false);
    } else {
      setIsValidName(true);
    }
  }, [name]);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const {
    isOpen: isOpenPasswordModal,
    onOpen: onOpenPasswordModal,
    onClose: onClosePasswordModal,
  } = useDisclosure();

  useEffect(() => {
    if (createUserRes.data?.createUser.password) {
      onOpenPasswordModal();
      setPassword(createUserRes.data.createUser.password);
    }
    if (createUserRes.data?.createUser.error) {
      toast({
        title: "ユーザーの作成に失敗しました。",
        description: createUserRes.data?.createUser.error,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  }, [createUserRes.data]);

  return (
    <>
      <BlueButton onClick={onOpen} label={"ユーザーを作成"} />
      <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>ユーザーを作成</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text pb={2} fontSize={20}>
              ユーザーを作成します。
            </Text>
            <Input
              placeholder={"名前"}
              onChange={(event) => {
                setName(event.target.value);
              }}
            />
          </ModalBody>
          <ModalFooter>
            <Flex>
              <BlueButton
                isDisabled={!isValidName}
                onClick={() => {
                  createUser(
                    {
                      input: {
                        name,
                      },
                    },
                    { additionalTypenames: ["User"] }
                  );
                  onClose();
                }}
                label={"作成"}
              />
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <ShowPasswordModal
        isOpen={isOpenPasswordModal}
        onClose={onClosePasswordModal}
        name={name}
        password={password}
      />
    </>
  );
};

const ShowPasswordModal = ({
  isOpen,
  onClose,
  name,
  password,
}: {
  isOpen: boolean;
  onClose: () => void;
  name: string | undefined;
  password: string | undefined;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={"xl"}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>ユーザーを作成しました。</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text pb={2} fontSize={20}>
            ユーザーを作成しました。
          </Text>
          <Text pb={2} fontSize={20} color="red.900">
            以下のパスワードは一度しか表示されません。
          </Text>
          <Text pb={2} fontSize={20}>
            必ずメモしてください。
          </Text>
          <Text pb={2} fontSize={20}>
            ユーザー名 : {name}
          </Text>
          <Text pb={2} fontSize={20}>
            パスワード : {password}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex>
            <BlueButton onClick={onClose} label={"ウィンドウを閉じる"} />
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
